import { TableViewItem } from "../../../../framework/tools/tableview/TableViewItem";
import { ChatCellView } from "./chat_cell_view";
import ModelData from "../../../public/model_data";
import { ChatType } from "./chat_view";
import { Notify } from "../../server/notify/proto_notify";
import { util } from "protobufjs";
import Utility from "../../../../utility/utility";

const {ccclass, property} = cc._decorator;

@ccclass
export class ChatCell extends TableViewItem {

    private chatItem:ChatCellView = null;

    onInit(key:string){
        this.chatItem = this.node.getComponent(ChatCellView);
    }

    onSetData(key:string, data:any, index:number, is_measure:boolean):[number, number]{   
        

        let gender : number = 1;

        this.chatItem.setData(data);
        
        if (data.type == ChatType.worldChat) {

            //console.log(" onSetData " + index);

            //console.log(" chat cell set data " , data.data);
            //这里要处理horn
            let isRole = data.data.userId == ModelData.instance.roleData.id 
                        
            let content : string;
            let showHorn : boolean;

            let contentData = data.data.content

            if (Utility.isJSON(contentData)) {
                let json = JSON.parse(contentData);    
                content = json.content;                
                showHorn = json.type == "horn";    
                gender = json.gender;
            }else{
                content = data.data.content;
                showHorn = false;
            }        
            
            this.chatItem.setContent(isRole,content,data.type,showHorn);

            this.chatItem.setUserId(data.data.userId);
            this.chatItem.setAvatar(isRole,data.data.avatar,gender);
            this.chatItem.setName(isRole,data.data.nickName);    

            //console.warn(" onSetData " , index , " content " , content)

    

        
        }else if (data.type == ChatType.friendChat) {

            let _data = <Notify.ChatMessage>data.data
            let isRole = _data.sendUserId == ModelData.instance.roleData.id
            let jsonStr=JSON.parse(_data.content)

            this.chatItem.setUserId(_data.sendUserId);
            this.chatItem.setContent(isRole,jsonStr.content,data.type);
            this.chatItem.setName(isRole,jsonStr.nickName);
            this.chatItem.setAvatar(isRole,jsonStr.avatar,jsonStr.gender);
        }
        let height = this.chatItem.getHeight() + 80;
        return [0, height];
    }
}
